import { Box, Button, Typography } from '@mui/material';

import { Colors } from '@/assets';
import { LinearProgress } from '@/components';

export const CardMonthlyBudget = () => {
    const value = 80;
    return (
        <Box sx={{ background: Colors.magnoliaWhite, borderRadius: 2, px: 2, py: 2.5 }}>
            <Typography variant="subtitle1" sx={{ fontWeight: 500, color: Colors.slateBlueViolet }}>
                Monthly Budget
            </Typography>
            <Typography variant="subtitle1" sx={{ color: Colors.mediumPurpleViolet, mt: 0.5, mb: 2 }}>
                {`You’re at ${value}% of your budget.`}
            </Typography>
            <LinearProgress determinate value={80} />
            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'START', mt: 2, gap: 0.6 }}>
                <Button sx={{ boxShadow: 'none', minWidth: 0, px: 0.2 }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: Colors.mediumSlateViolet }}>
                        Dismiss
                    </Typography>
                </Button>
                <Button sx={{ boxShadow: 'none' }}>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: Colors.slateBlueViolet }}>
                        View budget
                    </Typography>
                </Button>
            </Box>
        </Box>
    );
};
